import AmrMachines from "./AmrMachines";
export default AmrMachines